import { render, staticRenderFns } from "./coursePlay.vue?vue&type=template&id=2150f3ff&scoped=true&"
import script from "./coursePlay.vue?vue&type=script&lang=js&"
export * from "./coursePlay.vue?vue&type=script&lang=js&"
import style0 from "./coursePlay.vue?vue&type=style&index=0&id=2150f3ff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2150f3ff",
  null
  
)

export default component.exports